import { ResourceApi } from '../../resource/Resource';
import { currentUserSelector } from '../Users/selectors';
import { COMMENT } from '../resourceNames';
import { UPDATE_COMMENT } from './actions';

export function likeComment(commentId) {
  return (dispatch, getState) => {
    const state = getState();
    const currentUser = currentUserSelector(state);
    const voting = state.Comments.getIn(['byId', commentId, 'voting']);

    const newVoting = voting
      .set('votesUp', voting.get('votesUp').push(currentUser))
      .set('iLike', true);

    // preemptive disptch
    dispatch({
      type: UPDATE_COMMENT,
      commentId,
      changes: {
        voting: newVoting,
      },
    });
    ResourceApi.update(COMMENT, commentId, 'likeComment')
      .then((result) => {
        if (result && result.success) {
          delete result.success; // eslint-disable-line no-param-reassign
          // Set the voting data on success
          dispatch({
            type: UPDATE_COMMENT,
            commentId,
            changes: {
              voting: result,
            },
          });
        }
      })
      .catch(() => {
        // Revert on failure
        dispatch({
          type: UPDATE_COMMENT,
          commentId,
          changes: {
            voting,
          },
        });
      });
  };
}

export function unlikeComment(commentId) {
  return (dispatch, getState) => {
    const state = getState();
    const currentUser = currentUserSelector(state).get('profileName');
    const voting = state.Comments.getIn(['byId', commentId, 'voting']);
    const newVoting = voting
      .set(
        'votesUp',
        voting
          .get('votesUp')
          .filter((user) => currentUser !== user.get('profileName'))
      )
      .set('iLike', false);

    // preemptive disptch
    dispatch({
      type: UPDATE_COMMENT,
      commentId,
      changes: {
        voting: newVoting,
      },
    });
    ResourceApi.update(COMMENT, commentId, 'unlikeComment')
      .then((result) => {
        if (result && result.success) {
          delete result.success; // eslint-disable-line no-param-reassign
          dispatch({
            type: UPDATE_COMMENT,
            commentId,
            changes: {
              voting: result,
            },
          });
        }
      })
      .catch(() => {
        // Revert on failure
        dispatch({
          type: UPDATE_COMMENT,
          commentId,
          changes: {
            voting,
          },
        });
      });
  };
}

export function addComment(creationData) {
  return () => {
    // Note: commentToJSON is a legacy method. Going forward, new code should use "resource"
    return ResourceApi.create(COMMENT, creationData, ['commentToJSON']).then(
      (result) => {
        const comment = result[0][0];
        return comment;
      }
    );
  };
}
